const loadScript = (script, attrs) => new Promise((resolve, reject) => {
  var _a, _b;
  try {
    if (!script) {
      reject(new Error("no script source"));
    } else {
      let start;
      const newScript = document.createElement("script");
      newScript.src = script;
      if (attrs && ((_a = Object.keys(attrs)) == null ? void 0 : _a.length)) {
        for (const [k, v] of Object.entries(attrs)) {
          newScript.setAttribute(k, v);
        }
      }
      newScript.onload = () => resolve({
        scriptSrc: script,
        timing: { start, finish: window.performance.now() },
        el: newScript
      });
      newScript.onerror = () => reject(new Error("script load error"));
      (_b = document.querySelector("head")) == null ? void 0 : _b.appendChild(newScript);
      start = window.performance.now();
    }
  } catch (error) {
    reject(error);
  }
});
export {
  loadScript as default
};
//# sourceMappingURL=loadScript.mjs.map
